/* eslint-disable react/jsx-pascal-case */

import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import Dashboard from './components/Dashboard/Dashboard';
import OTP from './components/pages/OTP';
import UserDetails from './components/pages/UserDetails';
import Login from './components/pages/Login';
import RoleAssignmentForm from './components/pages/Role_Assignment';
import EmployeeStatus from './components/pages/EmployeeStatus';
import Upload_FormA26 from './components/pages/Upload_FormA26';
import UpdateProfile from './components/pages/UpdateProfile';
import Userstatus from './components/pages/UserStatus';
import TdsCredentials from './components/pages/TdsCredentials';
import PaymentStatus from './components/pages/Payment';
import FinalOtp from './components/pages/Finalotp';
import UploadBanners from './components/pages/UploadBanner';
import UserActionPage from './components/pages/UserAction';
import ScreenAllow from './components/pages/ScreenAllow';
import UserReferrals from './components/pages/Referal';
import {
  hydrateAuthFromLegacyStorage,
  useAuthStore,
} from './utils/authStore';

function App() {
  const role = useAuthStore((s) => s.role);
  const permissions = useAuthStore((s) => s.permissions);
  const user = useAuthStore((s) => s.user);
  const [hydrated, setHydrated] = useState(() =>
    useAuthStore.persist.hasHydrated()
  );

  useEffect(() => {
    const finish = () => {
      hydrateAuthFromLegacyStorage();
      setHydrated(true);
    };

    if (useAuthStore.persist.hasHydrated()) {
      finish();
      return undefined;
    }

    const unsub = useAuthStore.persist.onFinishHydration(finish);
    return unsub;
  }, []);

  if (!hydrated) {
    return null;
  }

  return (
    <div>
      <Routes>
        <Route
          path="/dashboard"
          element={
            <Dashboard
              loggedInUserRole={role}
              userPermissions={permissions}
            />
          }
        />
        <Route
          path="/admin/user/details"
          element={<UserDetails userPermissions={permissions} />}
        />
        <Route
          path="/admin/user/status"
          element={<Userstatus userPermissions={permissions} />}
        />
        <Route
          path="/admin/otp"
          element={<OTP userPermissions={permissions} />}
        />
        <Route
          path="/admin/addRole"
          element={<RoleAssignmentForm userPermissions={permissions} />}
        />
        <Route
          path="/admin/employee/details"
          element={<EmployeeStatus userPermissions={permissions} />}
        />
        <Route
          path="/admin/tdsdetails"
          element={<Upload_FormA26 userPermissions={permissions} />}
        />
        <Route
          path="/update/profile"
          element={
            <UpdateProfile userPermissions={permissions} user={user} />
          }
        />
        <Route
          path="/admin/tds/credential"
          element={<TdsCredentials userPermissions={permissions} />}
        />
        <Route
          path="/admin/tds/payment"
          element={<PaymentStatus userPermissions={permissions} />}
        />
        <Route
          path="/admin/final-otp"
          element={<FinalOtp userPermissions={permissions} />}
        />
        <Route
          path="/admin/banner"
          element={<UploadBanners userPermissions={permissions} />}
        />
        <Route
          path="/admin/user/action"
          element={<UserActionPage userPermissions={permissions} />}
        />
        <Route
          path="/admin/user/screen/permision"
          element={<ScreenAllow userPermissions={permissions} />}
        />
        <Route
          path="/admin/user/refral"
          element={<UserReferrals userPermissions={permissions} />}
        />
        <Route path="/" element={<Login />} />
      </Routes>
    </div>
  );
}

export default App;
